import ShortcutIcon from '@mui/icons-material/Shortcut';
import { Button, Tooltip, useTheme } from '@mui/material';
import { useNavigate } from 'react-router-dom';

function BackButton() {
  const theme = useTheme();
  const navigate = useNavigate();
  return (
    <Tooltip title="Back" arrow>
      <Button
        variant="contained"
        sx={{
          boxShadow: theme.shadows[4],
          position: 'absolute',
          right: '15px',
          top: '120px',
          background: '#ffffff',
          paddingLeft: '10px',
          paddingRight: '10px',
          minWidth: '0px',
          color: '#000000',
          ':hover': {
            background: '#efefef',
          },
        }}
        onClick={() => navigate(-1)}>
        <ShortcutIcon sx={{ transform: 'scale(-1, 1)' }} />
      </Button>
    </Tooltip>
  );
}

export default BackButton;
